import Icon from "@react-native-vector-icons/material-design-icons/static";
import { TouchableOpacity } from "react-native";
import { List } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type SavedMemoryItemMobileProps = {
	item: {
		text: string;
	};
	isSelected: boolean;
	onPress: (item: { text: string }) => void;
	onLongPress: (item: { text: string }) => void;
};

const SavedMemoryItemMobile = ({
	item,
	isSelected,
	onPress,
	onLongPress,
}: SavedMemoryItemMobileProps) => {
	const theme = useAppTheme();

	return (
		<TouchableOpacity
			onPress={() => {
				onPress(item);
			}}
			onLongPress={() => {
				onLongPress(item);
			}}
		>
			<List.Item
				title={item.text}
				titleNumberOfLines={4}
				onPress={() => {
					onPress(item);
				}}
				onLongPress={() => {
					onLongPress(item);
				}}
				left={() => (
					<Box width={40} alignItems="flex-end">
						{isSelected ? (
							<Icon
								name="checkbox-marked"
								size={24}
								color={theme.colors.primary}
							/>
						) : (
							<Box
								width={24}
								height={24}
								justifyContent="center"
								alignItems="center"
							/>
						)}
					</Box>
				)}
			/>
		</TouchableOpacity>
	);
};

export default SavedMemoryItemMobile;
